import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL } from '@images/imageUrls';
import { withRouter } from 'react-router-dom';
import { formatNumberToWan } from '@utils/formatNumber'
interface PcSidebarTopicListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    topicList?: any
    topicClick?: any

}


@inject('app', 'site', 'user')
@observer
class PCSidebarTopicList extends React.Component<PcSidebarTopicListProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }

    // 话题标签
    tagRender = (item) => {
        const tags: any = [];

        // 第一优先级标签, 规则 最多显示2个标签，第一个标签优先级：热>新>荐； 
        if (item?.isHot) {
            tags.push({ img: `${BASE_IMG_URL}/common/topic_hot.png`, alt: '热' });
        } else if (item?.isNew) {
            tags.push({ img: `${BASE_IMG_URL}/common/topic_new.png`, alt: '新' });
        } else if (item?.isRecommended) {
            tags.push({ img: `${BASE_IMG_URL}/common/topic_recommend.png`, alt: '推荐' });
        }
        if (tags.length === 0) {
            return null;
        }

        return (
            <div>
                {tags.map((tag, index) => (
                    <img
                        key={index}
                        src={tag.img}
                        alt={tag.alt}
                        className={styles.topicTag}
                        title={tag.alt}
                    />
                ))}
            </div>
        );
    };

    render() {
        const { site, app, topicList, topicClick } = this.props;
        
        return <>
            <div className={styles.topicListBox}>
                 <div className={styles.titleBox}>
                    <h1 className={styles.title}>热门话题</h1>
                    {/* <div className={styles.titleMore}>更多</div> */}
                 </div>
                 <div className={styles.topicList}>
                    {topicList?.map((item: any, index: any) => (
                        <div key={item?.id ?? `topic-${index}`} className={styles.topicItem} onClick={() => topicClick && topicClick(item)}>

                            <div className={styles.topicIndex}>{index + 1}</div>
                            <div className={styles.topicContent}>{item.name}</div>
                            {this.tagRender(item)}
                            {/* {item.isHot && <img src={`${BASE_IMG_URL}/common/topic_hot.png`} alt="" className={styles.topicTag}/>} */}
                            {/* <img src={`${BASE_IMG_URL}/common/topic_new.png`} alt="" className={styles.topicTag}/>
                            <img src={`${BASE_IMG_URL}/common/topic_prize.png`} alt="" className={styles.topicTag}/> */}
                            {/* {item.isRecommended && <img src={`${BASE_IMG_URL}/common/topic_recommend.png`} alt="" className={styles.topicTag}/>} */}
                            <div className={styles.postCount}>{formatNumberToWan(item?.discussionCount)}</div>
                        </div>
                    ))}
                 </div>
            </div>
        </>;

    }
}

export default PCSidebarTopicList;